import { useSnapshot } from "valtio";
import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { OspApiClientContext } from "../features/api/client";
import { rootStore } from "../store";
import { QUERY_KEYS } from "../config/constant";

export const useAgentDailyReport = (agentId: string = "0") => {
  const { memberApi } = useContext(OspApiClientContext);
  const {
    isLoggedIn,
    isLoading: isLoginLoading,
    isFetching: isLoginFetching,
  } = useSnapshot(rootStore.login);
  const { data, isLoading, isPending, isFetching, error } = useQuery({
    queryKey: [
      QUERY_KEYS.AGENT_DAILY_REPORT,
      isLoggedIn,
      `agent_id=${agentId}`,
    ],
    enabled: !!memberApi && isLoggedIn && !isLoginLoading && !isLoginFetching,
    queryFn: async () => {
      const res = await memberApi?.agents.dailyReport({
        agent_id: agentId,
      });
      return res?.data?.data;
    },
  });
  return {
    data,
    isLoading,
    isPending,
    isFetching,
    error,
  };
};
